export const GET_SALOONS_REQUEST = "GET_SALOONS_REQUEST";
export const GET_SALOONS_SUCCESS = "GET_SALOONS_SUCCESS";
export const GET_SALOONS_FAILURE = "GET_SALOONS_FAILURE";
export const GET_SALOON_INFO_REQUEST = "GET_SALOON_INFO_REQUEST";
